import { useFormContext } from "react-hook-form";
import Checkbox from "@/components/Checkbox/Checkbox";
import Checkboxes from "@/components/Checkbox/Checkboxes";
import type { IMedicalCompetence } from "@medoma/models/shifts";
import {
  medicalCompetenceDictionary,
  medicalCompetenceSchema,
} from "@medoma/models/shifts";
import { useLingui } from "@lingui/react/macro";
import { useEnabledCompetences } from "@/api/Shifts";
import { Loading } from "@medoma/components/Loading/Loading";
import ErrorMessage from "@medoma/components/ErrorMessage/ErrorMessage";

export type ICompetencePickerFields = {
  requiredCompetences: IMedicalCompetence[];
};

const CompetencePicker = ({ isRequired = false }: { isRequired?: boolean }) => {
  const {
    formState: { errors },
    register,
  } = useFormContext<ICompetencePickerFields>();
  const { t } = useLingui();
  const {
    data: enabledCompetences,
    isPending,
    isError,
  } = useEnabledCompetences();

  return (
    <Checkboxes
      legend={isRequired ? t`Kompetensbehov` : t`Kompetensbehov (valfri)`}
      errorMessage={errors.requiredCompetences?.message}
      orientation="horizontal"
    >
      {isPending ? (
        <Loading message={t`Hämtar lista med kompetenser`} />
      ) : isError ? (
        <ErrorMessage message={t`Kunde inte hämta lista med kompetenser`} />
      ) : (
        enabledCompetences.map((competence) => (
          <Checkbox
            key={competence}
            label={{ text: t(medicalCompetenceDictionary[competence].long) }}
            {...register(`requiredCompetences`, {
              required: {
                value: isRequired,
                message: t`Ange minst en kompetens`,
              },
            })}
            value={medicalCompetenceSchema.enum[competence]}
            visualStyle="framed"
          />
        ))
      )}
    </Checkboxes>
  );
};

export { CompetencePicker };
